import { useObserver } from 'mobx-react';
import { useCurrentOrg } from './useCurrentOrg';

export const useIsSubscriptionExpired = () => {
  const org = useCurrentOrg();
  return useObserver(() => org?.subscription?.isStatusCanceled());
};
